var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.83337V11.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58.3334V64.1667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 35H11.6668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3335 35H64.1668",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 52.5001L18.5006 51.4996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.499 18.5012L52.5003 17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4999 52.5001L51.4995 51.4996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5012 18.5012L17.5 17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5241 42.6627C44.894 46.478 45.0786 48.3858 43.9615 49.2337C42.8444 50.0819 41.1653 49.3087 37.8067 47.7623L36.9379 47.3621C35.9832 46.9228 35.5061 46.7029 35.0003 46.7029C34.4946 46.7029 34.0174 46.9228 33.0628 47.3621L32.1939 47.7623C28.8355 49.3087 27.1562 50.0819 26.0391 49.2337C24.922 48.3858 25.1068 46.478 25.4765 42.6627L25.5722 41.6757C25.6772 40.5916 25.7298 40.0494 25.5735 39.5469C25.4172 39.044 25.0697 38.6377 24.3748 37.8252L23.7421 37.0855C21.2967 34.2257 20.074 32.796 20.5007 31.424C20.8098 30.43 21.8362 29.9429 23.7421 29.4415M30.8487 25.3873C32.6959 22.0736 33.6196 20.4167 35.0003 20.4167C36.3811 20.4167 37.3048 22.0736 39.1519 25.3873L39.63 26.2446C40.1547 27.1862 40.4172 27.6571 40.8264 27.9677C41.2356 28.2784 41.7454 28.3937 42.7648 28.6243L43.6926 28.8343C47.2798 29.646 49.0732 30.0517 49.5 31.424C49.808 32.4142 49.2567 33.4341 48.0072 35.0001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.31a6cfc492a652caa9f681d0fd254c00.svg";
export { ForwardRef as ReactComponent };